import { useContext } from 'react'
import { useQuery, useMutation } from 'react-query'
import { apiGet, apiPost, apiPatch, apiDelete } from 'api'
import AuthContext from 'context/auth-context'

const getDashboardCharts = async (token, id) => {
  const url = `dashboards/${id}/charts`
  const data = await apiGet({ url, token })
  return data
}

export function useDashboardCharts({ id, options = {} }) {
  const token = useContext(AuthContext)
  const queryFn = () => getDashboardCharts(token, id)
  const queryKey = [`dashboards/${id}/charts`]
  return useQuery(queryKey, queryFn, { ...options })
}

const getChart = async (token, chartType, params) => {
  const url = `charts/${params.chart_id}`
  const paramsWithChartType = { ...params, chart_type: chartType }

  const data = await apiGet({ url, token, params: paramsWithChartType })
  return data
}

export function useDashboardChart({ chartType, params, options }) {
  const token = useContext(AuthContext)
  const queryKey = ['charts', chartType, params]
  const queryFn = () => getChart(token, chartType, params)

  return useQuery(queryKey, queryFn, {
    ...options
  })
}

const createDashboardChart = async (token, id, params) => {
  const url = `dashboards/${id}/charts`
  const objectName = 'dashboard_chart'
  const data = await apiPost({ url, token, objectName, params })
  return data
}

const updateDashboardChart = async (token, id, params) => {
  const url = `charts/${id}`
  const objectName = 'dashboard_chart'
  const data = await apiPatch({ url, token, objectName, params })
  return data
}

const destroyDashboardChart = async (token, id) => {
  const url = `charts/${id}`
  await apiDelete({ url, token })
}

const dashboardChartMutationOptions = (options = {}) => {
  return {
    onSuccess: () => {
      if (options?.onSuccess) {
        options.onSuccess()
      }
    }
  }
}

export function useCreateDashboardChart({ id, options }) {
  const token = useContext(AuthContext)

  return useMutation(
    (params) => createDashboardChart(token, id, params),
    dashboardChartMutationOptions(options)
  )
}

export function useUpdateDashboardChart({ dashboardId, options }) {
  const token = useContext(AuthContext)

  return useMutation(
    ({ id, ...params }) => updateDashboardChart(token, id, params),
    dashboardChartMutationOptions(options)
  )
}

export function useDestroyDashboardChart({ dashboardId, id, options }) {
  const token = useContext(AuthContext)

  return useMutation(
    () => destroyDashboardChart(token, id),
    dashboardChartMutationOptions(options)
  )
}
